import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createContext, useContext, useEffect, useMemo, useReducer, } from "react";
import { EMonitoringAction, INITIAL_STATE, loadState, monitoringReducer, placementValues, saveState, setPlacementValue, } from "./lib/state";
var noop = function () { return undefined; };
var NO_ACTIONS = {};
var NO_VALUES = {};
var MonitoringContext = createContext({
    state: INITIAL_STATE,
    selectDashboard: noop,
    setScope: noop,
    setWidgetValue: noop,
    widgetValues: function () { return NO_VALUES; },
    setMode: noop,
    actions: NO_ACTIONS,
});
var sessionStorageOrNothing = function () {
    try {
        return window.sessionStorage;
    }
    catch (_a) {
        return undefined;
    }
};
export function MonitoringProvider(_a) {
    var storageKey = _a.storageKey, _b = _a.actions, actions = _b === void 0 ? NO_ACTIONS : _b, children = _a.children;
    var _c = useReducer(monitoringReducer, storageKey, function (key) {
        return loadState(sessionStorageOrNothing(), key);
    }), state = _c[0], dispatch = _c[1];
    useEffect(function () { return saveState(sessionStorageOrNothing(), storageKey, state); }, [storageKey, state]);
    var value = useMemo(function () {
        var _a;
        var dashboardId = (_a = state.dashboardId) !== null && _a !== void 0 ? _a : "";
        return {
            state: state,
            selectDashboard: function (id) {
                return dispatch({ type: EMonitoringAction.SELECT_DASHBOARD, dashboardId: id });
            },
            setScope: function (scope) { return dispatch({ type: EMonitoringAction.SET_SCOPE, scope: scope }); },
            setWidgetValue: function (placement, name, selected) {
                return dispatch(setPlacementValue(dashboardId, placement, name, selected));
            },
            widgetValues: function (placement) { return placementValues(state, dashboardId, placement); },
            setMode: function (mode) { return dispatch({ type: EMonitoringAction.SET_MODE, mode: mode }); },
            actions: actions,
        };
    }, [state, actions]);
    return _jsx(MonitoringContext.Provider, { value: value, children: children });
}
export var useMonitoring = function () { return useContext(MonitoringContext); };
